import { StandaloneServices } from 'vscode/vscode/vs/editor/standalone/browser/standaloneServices';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ISnippetsService } from 'vscode/vscode/vs/workbench/contrib/snippets/browser/snippets.service';
import { SnippetsService } from 'vscode/vscode/vs/workbench/contrib/snippets/browser/snippetsService';
import { ILifecycleService } from 'vscode/vscode/vs/workbench/services/lifecycle/common/lifecycle.service';
import getServiceOverride$1 from '@codingame/monaco-vscode-files-service-override';
import { registerServiceInitializeParticipant } from 'vscode/lifecycle';
import './vscode/src/vs/workbench/contrib/snippets/browser/snippets.contribution.js';

registerServiceInitializeParticipant(async (accessor) => {
    void accessor.get(ILifecycleService).when(2 ).then(() => {
        StandaloneServices.get(ISnippetsService);
    });
});
function getServiceOverride() {
    return {
        ...getServiceOverride$1(),
        [( ISnippetsService.toString())]: new SyncDescriptor(SnippetsService, [], true)
    };
}

export { getServiceOverride as default };
